import { Component, Inject, OnInit, OnDestroy  } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ChallengeInlineDialogData {
  data?: any; 
}

// @Component({
//   selector: 'app-challenge-inline-dialog',
//   templateUrl: './challenge-inline-dialog.component.html',
//   styleUrls: ['./challenge-inline-dialog.component.scss']
// })
// export class ChallengeInlineDialogComponent implements OnInit {
//   state: 'pending'|'approved'|'denied'|'expired' = 'pending';
//   text = 'Waiting for approval on your device…';
//   expiresIn?: number; 
//   deviceName = 'device'; 
//   error:string;
//   constructor(@Inject(MAT_DIALOG_DATA) public dialogData: ChallengeInlineDialogData) {
//   }
//   ngOnInit(): void {
//    this.deviceName = this.dialogData?.data?.recently_device_info?.device_name || 'device';
//    this.expiresIn  = this.dialogData?.data?.expires_in;
//   }

//   setError(msg: string) {
//     this.error = msg;
//   }
// }

type AuthState = 'loading' | 'expired' | 'failed';

@Component({
  selector: 'app-challenge-inline-dialog',
  templateUrl: './challenge-inline-dialog.component.html',
  styleUrls: ['./challenge-inline-dialog.component.scss']
})
export class ChallengeInlineDialogComponent implements OnInit, OnDestroy {
  deviceName = 'device';
  state: AuthState = 'loading';
  test: boolean = false;
  errorMsg = '';
  expiresIn?: number;      // initial seconds from server
  remainingSec?: number;   // countdown
  private timer?: any;

  get isLoading() {
    return (this.state || '').toString().trim().toLowerCase() === 'loading';
  }

  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: ChallengeInlineDialogData, 
    private dialogRef: MatDialogRef<ChallengeInlineDialogComponent>
  ) {}

  ngOnInit(): void {
    this.deviceName  = this.dialogData?.data?.recently_device_info?.device_name || 'device';
    this.expiresIn   = this.dialogData?.data?.expires_in;
    this.state = 'loading';
    this.remainingSec = this.expiresIn;
    // start countdown if expires_in provided
    if (typeof this.remainingSec === 'number' && this.remainingSec > 0) {
      this.timer = setInterval(() => {
        if ((this.remainingSec as number) > 0) {
          this.remainingSec = (this.remainingSec as number) - 1;
        }
        if ((this.remainingSec as number) <= 0) {
          this.state = 'expired';
          this.clearTimer();
        }
      }, 1000);
    }
  }

  onResend() {
    this.dialogRef.close('resend');
  }

  ngOnDestroy(): void {
    this.clearTimer();
  }

  private clearTimer() {
    if (this.timer) { clearInterval(this.timer); this.timer = undefined; }
  }

  /** Call this from parent or inside to switch to "failed" state */
  setError(msg: string) {
    this.errorMsg = msg || 'Authentication failed. Please try again.';
    this.state = 'failed';
    this.clearTimer();
  }

  // optional: format mm:ss
  get ttl(): string | undefined {
    if (this.state !== 'loading' || typeof this.remainingSec !== 'number') return undefined;
    const m = Math.floor(this.remainingSec / 60);
    const s = this.remainingSec % 60;
    return `${String(s)}`;
    return `${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`;
  }
}
